import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from '@/common/services/language/language.service';
import { environment } from '@/env/environment';
import { TranslationsGetLanguageUseCase } from '@/core/domain/translation/usecases/translations-get-language.usecase';
import { Router } from '@angular/router';

@Component({
    selector: 'fe-menu-mobile',
    templateUrl: './menu-mobile.component.html',
    styleUrls: ['./menu-mobile.component.scss'],
})
export class MenuMobileComponent implements OnInit {
    @Input() isOpen = false;
    @Input() currentLangtxt: string | null = null;
    @Input() idiomaChange: string | null = null;

    public activeSubmenuIndex: number | null = null;
    public currentLanguage: 'en' | 'es' = 'es';
    public changeLangCode: 'es' | 'en' | null = null;
    public env: any;
    menuLangOpen = false;

    constructor(
        private languageService: LanguageService,
        private readonly getLanguage: TranslationsGetLanguageUseCase,
        private router: Router,
    ) {}

    menuItems = [
        {
            label: 'fe_menu_reservacion_link',
            subMenu: [
                {
                    label: 'fe_menu_do_reservacion_link',
                    link: '#doReservation',
                },
                {
                    label: 'fe_menu_go_reservacion_link',
                    link: 'check-your-reservation',
                },
            ],
            isOpen: false,
            arrowIcon: true,
        },
        {
            label: 'fe_menu_promociones_link',
            link: 'promos-and-agreements',
            extern: false,
        },
        { label: 'Blog', link: 'https://www.alamo.com.mx/blog/', extern: true },
        { label: 'fe_menu_empresas_link', link: 'corporate', extern: false },
        {
            label: 'fe_menu_precheckin_link',
            link: 'pre-check-in',
            extern: false,
        },
        {
            label: 'fe_menu_destination_link',
            link: 'locations-and-offices',
            extern: false,
        },
    ];

    ngOnInit(): void {
        this.env = environment;
        this.setCurrentLanguageFromUrl();
    }

    private setCurrentLanguageFromUrl(): void {
        const currentUrl = this.router.url;
        const languageCode = currentUrl.split('/')[1];

        if (languageCode === 'es' || languageCode === 'en') {
            this.currentLanguage = languageCode as 'es' | 'en';
        }
    }

    toggleSubMenu(index: number) {
        this.menuItems[index].isOpen = !this.menuItems[index].isOpen;
    }
    public toggleSubmenuLang(): void {
        this.menuLangOpen = !this.menuLangOpen;
    }

    public onClickChangeLang(): void {
        this.changeLangCode = this.currentLanguage === 'es' ? 'en' : 'es';

        window.location.replace(
            [environment.baseUrl, this.changeLangCode].join('/'),
        );
    }
}
